<template>
    <div ref="markdownMessage" :class="['message', message.role]">
        <div class="message-deep-seek" v-if="message.deepSeek">
            <div class="header" @click="switchExpand">
                <template v-if="message.deepSeekTime">
          <span v-if="message.deepSeekTime > 0">
            <img src="../assets/deep.png" alt="" width="12" style="margin-right: 5px;">
            已深度思考（用时：{{ message.deepSeekTime }}秒）</span>
                    <span v-else>思考中...</span>
                </template>
                <span v-else>思考过程</span>
                <span class="expand" :class="{'el-icon-arrow-down': !expand, 'el-icon-arrow-up': expand }"/>
            </div>
            <div class="content" v-html="markdown ? markdownToHtml(message.deepSeek) : message.deepSeek" v-if="expand"/>
        </div>
        <div
            v-if="message.vipExpiredRechargeTip"
            class="message-vip-expired-tip"
            role="button"
            tabindex="0"
            @click="goRechargeVip"
            @keydown.enter.prevent="goRechargeVip"
        >
            {{ message.content }}
        </div>
        <div v-else class="message-content" v-html="markdown ? markdownToHtml(message.content) : message.content"/>
        <div class="message-risk-tip" v-if="message.role === 'assistant' && !message.vipExpiredRechargeTip">
      <span class="risk-tip-content">
      （注：以上内容为摩投AI基于市场公开信息梳理，仅供参考不构成投资建议。）
      </span>
        </div>
        <div class="message-citation" v-if="message.citations && message.citations.length > 0">
            <div class="header" @click="switchCitationExpand">
                <span>& 参考 {{message.citations.length}} 篇资料 </span>
                <span class="expand" :class="{'el-icon-arrow-down': !citationExpand, 'el-icon-arrow-up': citationExpand }"/>
            </div>

            <template v-for="citation in message.citations" v-if="citationExpand">
                <a class="citation-item" :href="citation.url" target="_blank">
                    <h4 class="citation-item-title">
                        {{ citation.title }}
                    </h4>
                    <div class="citation-item-bottom">
                        <img class="citation-item-icon" :src="citation.icon">
                        <span>{{ citation.source }}  {{ parseHost(citation.url) }}</span>
                    </div>
                </a>
            </template>
        </div>
    </div>
</template>

<script>
import { marked } from 'marked'
import hljs from 'highlight.js';
import 'highlight.js/styles/atom-one-dark.css'; // Atom One Dark 主题
import { EventBus } from '@/eventBus';
export default {
  name: 'MarkdownItem',
  props: {
    // 是否进行markdown解析
    markdown: {
      type: Boolean,
      default: true,
    },
    // 消息对象
    message: {
      type: Object,
      default: () => ({
        role: 'assistant',  //角色
        content: '',        //回答内容
        deepSeek: '',       //思考过程
        deepSeekTime: 0,    //思考时长
        citations: []       //引用
      })
    },
    initExpand: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    marked.setOptions({
      renderer: new marked.Renderer(),
      highlight: function (code, language) {
        const validLanguage = hljs.getLanguage(language) ? language : 'plaintext';
        return hljs.highlight(validLanguage, code).value;
      },
      pedantic: false,
      gfm: true,
      breaks: false,
      sanitize: false,
      smartLists: true,
      smartypants: false,
    });

    return {
      expand: this.initExpand,
      citationExpand: false,
    }
  },
  mounted() {
    this.$nextTick(() => this.addCopyButtons())
  },
  updated() {
    this.$nextTick(() => this.addCopyButtons())
  },
  methods: {
    // 添加复制按钮
    addCopyButtons() {
      const codeBlocks = this.$refs.markdownMessage.querySelectorAll('pre code');
      codeBlocks.forEach((block) => {
        const copyButton = document.createElement('button');
        copyButton.className = 'copy-button';
        copyButton.innerText = '复制';

        const pre = block.parentElement;
        pre.style.position = 'relative';
        pre.appendChild(copyButton);

        copyButton.addEventListener('click', () => {
          navigator.clipboard.writeText(block.textContent).then(() => {
            copyButton.innerText = '已复制！';
            setTimeout(() => {
              copyButton.innerText = '复制';
            }, 2000);
          });
        });
      });
    },
    // markdown转html
    markdownToHtml(markdown) {
      if (!markdown) return '';
      return marked.parse(markdown);
    },
    switchExpand() {
      this.expand = !this.expand
    },
    switchCitationExpand() {
      this.citationExpand = !this.citationExpand
    },
    parseHost(url) {
      try {
        return new URL(url).hostname;
      } catch (e) {return ""}
    },
    goRechargeVip() {
      if (!this.message.vipExpiredRechargeTip) return;
      EventBus.$emit('persist-chat-state');
      this.$router.push({ name: 'recharge-vip' });
    },
  },
}
</script>

<style scoped lang="scss">
.message {
  margin: 5px 0;
  padding: 10px;
  border-radius: 10px;
  width: fit-content;
  max-width: 100%;
  transition: width 0.3s ease-out;
  color: rgb(41, 45, 52);
  font-size: 16px;
  font-weight: 400;
  line-height: 180%;

}
.message-deep-seek {
  position: relative;
  padding: 16px 14px;
  color: #666;
  font-size: 14px;
  line-height: 150%;
  border-radius: 12px;
  //background-color: #daeaff;
  background-color: #f0f0f0;

  .header {
    color: #515A6E;
    font-size: 16px;
    font-weight: bold;

    .expand {
      cursor: pointer;
      float: right;
      font-weight: bold;
      font-size: 16px;
    }
  }
  .content {
    border-left: 2px solid #b4c0d0;
    padding-left: 10px;
  }
}
::v-deep .message-content {
  overflow-wrap: anywhere;

  table {
    width: 100%;
    font-size: 14px;
    border-collapse: collapse;
    border-spacing: 0;
    border: 1px solid #ddd;

    th {
      text-align: left;
      background-color: #E8EBF8;
      padding: 10px;
      border: 1px solid #ccc;
    }

    td {
      text-align: left;
      padding: 10px;
      border: 1px solid #ccc;
    }
  }

  pre {
    background-color: #1E1E1E; /* Atom One Dark 主题背景色 */
    padding: 10px;
    border-radius: 8px;
    color: #abb2bf;
    position: relative;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    code {
      font-family: ui-monospace,"JetBrains Mono", SFMono-Regular,SF Mono,Menlo,Consolas,Liberation Mono,monospace,"JetBrains Mono";

    }

    .copy-button {
      position: absolute; /* 绝对定位 */
      top: 10px; /* 距离顶部 10px */
      right: 10px; /* 距离右侧 10px */
      background-color: #9999AA; /* 按钮背景色 */
      color: white; /* 按钮文字颜色 */
      border: none; /* 去掉边框 */
      padding: 5px 10px; /* 内边距 */
      border-radius: 4px; /* 圆角 */
      cursor: pointer; /* 鼠标悬停时显示手型 */
      font-size: 12px; /* 字体大小 */
      z-index: 10; /* 确保按钮在代码块之上 */
      &:hover {
        background-color: #444444; /* 鼠标悬停时的背景色 */
      }
    }
  }
}
.message-vip-expired-tip {
  cursor: pointer;
  color: #c45656;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 3px;
  line-height: 180%;
}
.message-vip-expired-tip:hover {
  color: #a63d3d;
}

.message-risk-tip {
  color: red;
}

.message-citation {
  padding: 16px 14px;
  border-radius: 12px;
  font-size: 14px;
  color: #666;
  background-color: #f0f0f0;
  .header {
    color: #515A6E;
    font-size: 16px;
    font-weight: bold;

    .expand {
      cursor: pointer;
      float: right;
      font-weight: bold;
      font-size: 16px;
    }
  }

  .citation-item {
    display: block;
    padding: 5px 12px;
    line-height: 14px;
    border-radius: 12px;
    /* meto 定制 */
    text-decoration: none;
    color: #666;


    &:hover {
      background-color: #FFF;
    }
    .citation-item-title {
      margin: 5px 0;
      color: #666;
    }
    .citation-item-bottom {
      display: flex;
      align-items: center;
      gap: 5px;

      .citation-item-icon {
        width: 16px;
        height: 16px;
        border-radius: 50%;
      }
    }
  }
}

.user {
  background-color: #E0DFFF;
  background-color: #F7A925;
  color: #fff;
  align-self: flex-end;
}
.assistant {
  background-color: #ffffff;
  align-self: flex-start;
  padding: 16px;
  width: 90%;
}

@media (max-width: 768px) {
  .message {
    padding: 8px;
    font-size: 14px;
    line-height: 170%;
  }

  .message-deep-seek,
  .message-citation {
    padding: 12px;
    font-size: 13px;

    .header {
      font-size: 14px;
    }
  }

  .user {
    max-width: 88%;
  }

  .assistant {
    width: 100%;
    padding: 12px;
  }

  ::v-deep .message-content {
    table {
      display: block;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }
  }
}
</style>
